import React, { useEffect, useState, useMemo } from "react";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import css from "../common/anomalyMagneticStyle.less";
import ADSitesView from "../ADSitesView";
import ADUsageView from "../ADUsageView";
import BetaTag from "../../../../../common/BetaTag";
import FeatureDisabled from "../../../../../generics/authorization/FeatureDisabled";
import { sitesWidgetVisibility } from "../common/adUtils";
import AppHoc from "../../../../../generics/AppHOC";
import PropTypes from "prop-types";
import { getADUsageAccess, getADAccess } from "../../../../../utils/license";
import { getCircuitsData } from "../../../../circuits/common/masterTableUtil";
import { FEATURE_CONFIG } from "../../../../../utils/enums";
import useI18n from "../../../../../i18n/useI18n";
import PredictiveNetworksTabs from "../../../PredictiveNetworksTabs";

const [HbrCard, HbrTabGroup, HbrTab] = reactWrapper([
  "hbr-card",
  "hbr-tab-group",
  "hbr-tab",
]);

const ADTabs = (props) => {
  const { tViews } = useI18n("views");
  const adAccess = useMemo(() => getADAccess(), []);
  const adUsageAccess = useMemo(() => getADUsageAccess(), []);
  const [selectedTab, setSelectedTab] = useState(null);

  useEffect(() => {
    const storedTab = localStorage.getItem("selectedADTab");
    storedTab
      ? setSelectedTab(storedTab)
      : setSelectedTab(tViews("usageBasedAD.sitesTab"));

    const fetchData = async () => {
      let res = await getCircuitsData(props.globalFilter.globalV4Payload);
      const data = {
        data: [],
      };
      if (!res.errorObject) Object.assign(data, res.data);
      props.setCircuitsData(data);
    };
    fetchData();
  }, []);

  const onTabsChange = (tab) => {
    setSelectedTab(tab);
    sitesWidgetVisibility(tab);
    localStorage.setItem("selectedADTab", tab);
  };

  const renderTabs = (tabId, tab, tabAD, tabType) => {
    return (
      <>
        <HbrTab
          slot="nav"
          id={tabId}
          role="tab"
          aria-selected={selectedTab === tab}
          aria-controls="ad-panel-sites"
          active={selectedTab === tab}
          key={tab}
          panel={tab}
          onHbr-active={() => onTabsChange(tab)}
        >
          <div>{tabAD}</div>
          {FEATURE_CONFIG[tabType].isBeta === true && (
            <div slot="suffix">
              <BetaTag />
            </div>
          )}
        </HbrTab>
      </>
    );
  };

  const tabContentRender = (tab, panelId, tabId, component, access) => {
    return (
      <>
        {selectedTab === tab && access.enabled === true ? (
          <div
            id={panelId}
            role="tabpanel"
            aria-labelledby={tabId}
            hidden={selectedTab !== tab}
          >
            {component}
          </div>
        ) : (
          <FeatureDisabled />
        )}
      </>
    );
  };

  return (
    <HbrCard className={css["ad-tabs-container"]} container={true}>
      <PredictiveNetworksTabs />
      <HbrTabGroup
        className={css["ad-subtabs"]}
        aria-label={
          tViews("a11yLabels.tabsGroupLabel") ||
          tViews("a11yLabels.anomalyDetectionTabs")
        }
      >
        {renderTabs(
          "ad-tab-sites",
          "sitesTab",
          tViews("usageBasedAD.sitesAD"),
          "AD",
        )}
        {adUsageAccess.available === true &&
          renderTabs(
            "ad-tab-usage",
            "usageTab",
            tViews("usageBasedAD.usageAD"),
            "ADUSAGE",
          )}
      </HbrTabGroup>
      {selectedTab === "sitesTab" &&
        tabContentRender(
          "sitesTab",
          "ad-panel-sites",
          "ad-tab-sites",
          <ADSitesView />,
          adAccess,
        )}
      {selectedTab === "usageTab" &&
        tabContentRender(
          "usageTab",
          "ad-panel-usage",
          "ad-tab-usage",
          <ADUsageView />,
          adUsageAccess,
        )}
    </HbrCard>
  );
};

ADTabs.propTypes = {
  globalFilter: PropTypes.object.isRequired,
  setCircuitsData: PropTypes.func.isRequired,
};

export default AppHoc(ADTabs);
